import React from 'react';
import styles from './Field.module.css';
import {Field, useField} from 'formik';
import { ReactComponent as CheckedIcon } from '../../icons/unchecked.svg';
import { ReactComponent as UncheckedIcon } from '../../icons/checked.svg';


const FieldCheckbox = ({ label, name, id = name, onChange }) => {
    const [field, meta, helpers] = useField(name);

    const handleChange = (e) => {
        field.onChange(e);
        if (onChange) onChange(e);
    };

    return (
        <div className={`${styles.field} ${styles["checkbox"]}`}>
            <label htmlFor={id}>
                <Field
                    type={"checkbox"}
                    name={name}
                    id={id}
                    onChange={onChange ? handleChange : field.onChange}
                />
                {field.value ? <UncheckedIcon/> : <CheckedIcon/>}
                {label}
            </label>
            {meta.touched && meta.error ? <div className={"error"} style={{ color: "var(--clr-error)", fontSize: "var(--fs-secondary)"}}>{meta.error}</div> : null}
        </div>
    )
        ;
};

export default FieldCheckbox;
